import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";

import {
	slideInLeftAnimation,
	slideInRightAnimation,
	slideOutLeftAnimation,
	slideOutRightAnimation,
} from "angular-animations";
@Component({
	selector: "app-cbta-form-navigator",
	templateUrl: "./cbta-form-navigator.component.html",
	styleUrls: ["./cbta-form-navigator.component.scss"],
	animations: [
		slideInLeftAnimation({ duration: 500 }),
		slideInRightAnimation({ duration: 500 }),
		slideOutLeftAnimation({ duration: 500 }),
		slideOutRightAnimation({ duration: 500 }),
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class CbtaFormNavigatorComponent implements OnInit {
	@Input() isIn = true;
	@Input() left = true;

	constructor() {}

	ngOnInit(): void {}

	get right() {
		return !this.left;
	}

	get isOut() {
		return !this.isIn;
	}
}
